import { postApi, getApi, uploadApi } from "@/util/http.js";

/**获取用户可投稿作品列表
 * @param {String} title  搜索标题
 */
export const chooseFile = (data) =>
  getApi(`/admin/community/path/chooseFile`, data);

/**查询用户文件下一层级的内容
 * @param {integer} pfid   文件夹上级pfid
 */
export const findMindMapContent = (data) =>
  getApi(`/admin/community/path/chooseFile/Content`, data);

/**用户投稿
 * @param {String} fileId 文件id
 * @param {String} fileType   文件类型
 * @param {String} title  标题
 * @param {String} imageUrl 封面图片地址
 * @param {String} introduction 摘要
 * @param {Inter} classification 内容类别
 * @param {Inter} label  标签 多个标签用逗号隔开
 * @param {String} description  详细介绍
 * @param {String} subscriptionMsg 订阅动态
 * @param {String} permission  权限 0：不可编辑 1：可编辑
 * @param {String} status //状态 0：草稿 2:审核中 3：已通过 4：未通过 5:下架
 *
 */
export const contributeToComm = (data) =>
  postApi("/admin/community/path/contributeToComm", data);

/**我的投稿作品列表
 * @param {String} current  当前页数
 * @param {String} limit   每页条数
 * @param {String} status 状态 0：草稿 2:审核中 3：已通过 4：未通过
 */
export const findMySubmission = (data) =>
  getApi("/admin/community/path/findMySubmission", data);

/**我的投稿数量
 */
export const getSubmissionCount = () =>
  getApi("/admin/community/path/submission/count");

/**  查询用户关注与粉丝列表
 *  @param {String} userId   用户id
 */
export const findFollowAndFans = (data) =>
  postApi("/admin/community/path/followers/or/fans", data);

/** 查询用户信息
 *  @param {String} userId 用户id
 */
export const findUserInfo = (data) =>
  postApi("/admin/community/path/findUserInfo", data);

/** 查询用户投稿作品
 *  @param {String} userId 用户id
 *  @param {Number} current  当前页数
 *  @param {Number} limit   每页条数
 *  @param {Number} sort    排序 0:默认排序，1：获赞排序
 */
export const getCommBox = (data) =>
  postApi("/admin/community/path/getCommBox", data);

/** 删除我的投稿作品
 *  @param {String} id  文件id
 */
export const deleteMySubmission = (param) =>
  getApi("/admin/community/path/delete/mySubmission", param);

/** 获取我的消息列表
 *  @param {String} current  当前页数
 *  @param {String} limit   每页条数
 */
export const getMyMessage = (param) =>
  getApi("/admin/community/path/findCommNotifByPage", param);

/** 标记已读
 *  @param {String} id  消息id
 *  @param {String} type  已读类型 系统通知0 我的关注1 订单通知2
 */
export const readMessage = (param) =>
  getApi("/admin/community/path/readMessage", param);

/** 同步更新投稿内容
 *  @param {String} id  社区id
 */
export const syncUpdateToComm = (data) =>
  postApi("/admin/community/path/syncUpdateToComm", data);

/** 获取用户小班级列表
 */
export const findOwnClass = (params) =>
  getApi("/admin/class/findOwnClass", params);
